export const personalLetterEnvelopeStyleImageMap = {
    'Blue Mosaic': '/assets/products/envelope-styles/blue-mosaic.png',
    'Lavender Embossed':
        '/assets/products/envelope-styles/lavender-embossed.png',
    Lemon: '/assets/products/envelope-styles/lemon.png',
    'Orange Quatrefoil':
        '/assets/products/envelope-styles/orange-quatrefoil.png',
    'Solid White': '/assets/products/envelope-styles/solid-white.png',
    'Grey Herringbone': '/assets/products/envelope-styles/grey-herringbone.png',
    'Navy Blue w/ White Gel':
        '/assets/products/envelope-styles/navy-blue-white-gel-pen.png',
}

export const professionalLetterEnvelopeStyleImageMap = {
    'Blue Hexagon': '/assets/products/envelope-styles/blue-hexagon.png',
    'Grey Pastel': '/assets/products/envelope-styles/grey-pastel.png',
    White: '/assets/products/envelope-styles/white.png',
    'Orange Mosaic': '/assets/products/envelope-styles/orange-mosaic.png',
    'Yellow Arrows': '/assets/products/envelope-styles/yellow-arrows.png',
}

const isProfessionalLetterEnvelopeProduct = (product) => {
    const slug = String(product?.slug || '').toLowerCase()
    const name = String(product?.name || '').toLowerCase()

    return (
        slug === 'professional-letters' ||
        slug === 'real-penned-professional-letters' ||
        name.includes('professional letters')
    )
}

const isWhiteEnvelopeStyle = (value) => {
    const normalized = String(value || '')
        .toLowerCase()
        .trim()

    return normalized === 'white' || normalized.includes('solid white')
}

const getEnvelopeStyleImageMap = (product) =>
    isProfessionalLetterEnvelopeProduct(product)
        ? professionalLetterEnvelopeStyleImageMap
        : personalLetterEnvelopeStyleImageMap

const findEnvelopeStyleImage = (value, product) => {
    const imageMap = getEnvelopeStyleImageMap(product)

    if (isWhiteEnvelopeStyle(value)) {
        return imageMap.White || imageMap['Solid White']
    }

    const normalized = String(value || '')
        .toLowerCase()
        .trim()
    const exactMatchImage = imageMap[value]

    if (exactMatchImage) return exactMatchImage

    const partialMatch = Object.entries(imageMap).find(([key]) =>
        normalized.includes(String(key).toLowerCase()),
    )

    return partialMatch?.[1]
}

export const envelopeSwatchStyle = (value, product) => {
    const normalized = String(value || '').toLowerCase()
    const matchedImage = findEnvelopeStyleImage(value, product)

    if (matchedImage) {
        return {
            backgroundImage: `url('${matchedImage}')`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
        }
    }

    if (normalized.includes('lemon')) {
        return {
            background: 'linear-gradient(135deg,#fff7cf,#ffe27a)',
        }
    }

    if (normalized.includes('navy blue')) {
        return {
            background: 'linear-gradient(135deg,#6f8aa3,#59758f)',
        }
    }

    if (normalized.includes('lavender')) {
        return {
            background: 'linear-gradient(135deg,#efe6fb,#cdb6f0)',
        }
    }

    if (normalized.includes('blue mosaic')) {
        return {
            background:
                'repeating-linear-gradient(45deg,#dfeaf6 0 6px,#cadcf0 6px 12px)',
        }
    }

    if (normalized.includes('blue hexagon')) {
        return {
            background:
                'repeating-radial-gradient(circle at 6px 6px,#dce7f5 0 4px,#fff 4px 10px)',
        }
    }

    if (normalized.includes('grey herringbone')) {
        return {
            background:
                'repeating-linear-gradient(125deg,#ededed 0 6px,#dadada 6px 12px)',
        }
    }

    if (normalized.includes('grey pastel')) {
        return {
            background: 'linear-gradient(135deg,#f1f1f1,#d7d7d7)',
        }
    }

    if (normalized.includes('orange')) {
        return {
            background:
                'repeating-radial-gradient(circle at 6px 6px,#f6dcc5 0 4px,#fff 4px 10px)',
        }
    }

    if (normalized.includes('yellow')) {
        return {
            background: 'linear-gradient(135deg,#ffe453,#ffd500)',
        }
    }

    if (normalized.includes('white')) {
        return {
            background: '#f3f3f3',
        }
    }

    return {
        background:
            'repeating-linear-gradient(125deg,#e9e9e9 0 5px,#dcdcdc 5px 9px)',
    }
}
